import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Tab, Tabs, units } from '@hbf/dsl';
import { Imgix } from 'ha/modules/Image/Imgix';

const useStyles = makeStyles()(theme => ({
  tabsIndicator: {
    display: 'none',
  },
  tabsScrollButtons: {
    color: theme.palette.grey[200],
  },
  tabRoot: {
    minWidth: 'auto',
    padding: 0,
    margin: theme.spacing(0, 0.5, 0.75),
    transition: 'all 0.2s ease-in-out',
    border: units.border(3, 'solid', 'transparent'),
  },
  tabContent: {
    height: 60,
    width: 'auto',
  },
  tabSelected: {
    borderColor: theme.palette.secondary.main,
  },
}));

interface Props {
  handleChangeIndex: (index: number) => void;
  thumbnails: string[];
  index: number;
}

const GalleryThumbnails: React.FC<Props> = ({
  handleChangeIndex,
  thumbnails,
  index,
  ...props
}) => {
  const { classes } = useStyles();

  return (
    <Tabs
      value={index}
      onChange={(_, value) => handleChangeIndex(value)}
      variant="scrollable"
      scrollButtons
      classes={{
        indicator: classes.tabsIndicator,
        scrollButtons: classes.tabsScrollButtons,
      }}
      {...props}
      allowScrollButtonsMobile
    >
      {thumbnails.map(picture => (
        <Tab
          key={picture}
          classes={{
            root: classes.tabRoot,
            selected: classes.tabSelected,
          }}
          label={
            <Imgix className={classes.tabContent} sizes="160px" src={picture} />
          }
        />
      ))}
    </Tabs>
  );
};

export { GalleryThumbnails };
